import { Reducer } from "redux";

import { GetServiceProviderDataResponse } from "../models/Api/Service";
import { ServiceProviderDetailDispatchTypes } from "../models/DispatchTypes/Service";
import { ServiceProviderActionDispatchType } from "../constants/Service";

const initialState: GetServiceProviderDataResponse = {
  loading: false,
  response: {
    referralId: -1,
    referralServiceProviderId: 0,
    serviceProviderId: null,
    providerName: "",
    providerNpi: "",
    streetName1: null,
    streetName2: null,
    providerCity: null,
    providerCounty: null,
    providerState: null,
    zipCode: null,
    userCreated: null,
    providerId: 0,
    plexisOfficeId: 0,
    phone: "",
    extension: "",
    isOutOfNetwork: false,
  },
};

const ServiceProviderDataReducer: Reducer<
  GetServiceProviderDataResponse,
  ServiceProviderDetailDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case ServiceProviderActionDispatchType.GET_SERVICE_PROVIDER_DETAIL_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case ServiceProviderActionDispatchType.GET_SERVICE_PROVIDER_DETAIL_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case ServiceProviderActionDispatchType.GET_SERVICE_PROVIDER_DETAIL_RESET: {
      return initialState;
    }
  }
  return state;
};

export default ServiceProviderDataReducer;
